import { useQuery } from '@tanstack/react-query'
import { supabase, type Trip } from '../lib/supabase'

export const TRIPS_KEY = (householdId: string) => ['trips', householdId] as const

// The household's recorded trips (037), newest first, for the stats page —
// deleted ones too (046), whose history rows the stats leave out.
// Fetched when the page opens and kept for a few minutes: a trip finished in
// the meantime only changes the stats by one.
const LIMIT = 500

export function useTrips(householdId: string, enabled = true): { trips: Trip[]; loaded: boolean } {
  const { data } = useQuery({
    queryKey: TRIPS_KEY(householdId),
    enabled: enabled && !!householdId,
    staleTime: 1000 * 60 * 5,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('trips').select('id, household_id, store_id, started_by, started_at, finished_at, finished_on, finished_by, items, cost, currency, updated_at, picked_order, deleted_at')
        .eq('household_id', householdId)
        .order('started_at', { ascending: false })
        .limit(LIMIT)
      if (error) throw error
      return data as Trip[]
    },
  })
  return { trips: data ?? [], loaded: !!data }
}
